import CouponService, {
  RedeemCouponDto,
  RedeemCouponResponse,
} from "@/services/couponService";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

export default function useRedeemCoupon(
  options?: UseMutationOptions<RedeemCouponResponse, Error, RedeemCouponDto, unknown>,
) {
  const couponService = new CouponService();

  return useMutation({
    mutationFn: (data: RedeemCouponDto) => couponService.redeemCoupon(data),
    ...options,
  });
}
